import React, { useState } from 'react';
import { Modal, ModalBody, ModalHeader, ModalFooter } from 'reactstrap';

import ENUMS from '../../../../enums';
import { dataGenerator, formatter } from '../../../../utils';

const AddOrEditTableModal = props => {
  const [num, setNum] = useState(props.num);
  const [totalChairs, setTotalChairs] = useState(props.totalChairs);
  const [tableTitle, setTableTitle] = useState(props.tableTitle);

  const [allowSmoking, setAllowSmoking] = useState(props.allowSmoking);
  const [haveHeatSystem, setHaveHeatSystem] = useState(props.haveHeatSystem);
  const [hasCoolingSystem, sethasCoolingSystem] = useState(
    props.hasCoolingSystem,
  );
  const [hasFogSpray, sethasFogSpray] = useState(props.hasFogSpray);
  const [inputAmount, setinputAmount] = useState(props.inputAmount);
  const [showInput, setShowInput] = useState();
  const [hasInput, sethasInput] = useState(props.hasInput);

  const [floor, setFloor] = useState(props.floor);
  const [location, setLocation] = useState(props.location);

  const [numInputInvalidMessage, setNumInputInvalidMessage] = useState('');
  const [numInputValidateStatus, setNumInputValidateStatus] = useState('');
  const [inputAmountValidStatus, setInputAmountValidStatus] = useState('');
  const [inputAmountValidMessage, setInputAmountValidMessage] = useState('');

  const cancel = () => {
    props.closeModal();
  };

  const onChangeNum = event => {
    const num = event.target.value;
    if (num >= 1 && num <= 120) {
      setNum(num);
      setNumInputInvalidMessage('');
      setNumInputValidateStatus('');    }
  };

  const onChangeTotalChairs = event => {
    const totalChairs = event.target.value;
    if (totalChairs >= 1 && totalChairs <= 50) {
      setTotalChairs(totalChairs);
    }
  };

  const onChangeTableTitle = event => {
    const newTableTitle = event.target.value;
    setTableTitle(newTableTitle);
  };

  const onChangeTableFloor = event => {
    const floor = event.target.value;
    setFloor(floor);
  };

  const onChangeAllowSmoking = event => {
    const allowSmoking = event.target.checked;
    setAllowSmoking(allowSmoking);
  };

  const onChangeHaveHeatSystem = event => {
    const haveHeatSystem = event.target.checked;
    setHaveHeatSystem(haveHeatSystem);
  };

  const onChangehasCoolingSystem = event => {
    const hasCoolingSystem = event.target.checked;
    sethasCoolingSystem(hasCoolingSystem);
  };

  const onChangehasFogSpray = event => {
    const hasFogSpray = event.target.checked;
    sethasFogSpray(hasFogSpray);
  };

  const onChangeLocation = event => {
    const location = event.target.value;
    setLocation(location);
  };

  const handelOpenModal = () => {
    if (props.hasInput) {
      const entranceInput = document.getElementById('entrance');
      entranceInput.style.display = 'block';
      let inputamount = parseInt(props.inputAmount);
      setShowInput(inputamount.toLocaleString());
    }
  };

  const onChangehasInput = event => {
    const hasInput = event.target.checked;
    const entranceInput = document.getElementById('entrance');

    if (hasInput) {
      sethasInput(true);
      entranceInput.style.display = 'block';
    } else {
      sethasInput(false);
      entranceInput.style.display = 'none';
    }
  };

  const onChangeinputAmount = event => {
    const entrance = event.target.value;
    const showInput = new Intl.NumberFormat().format(entrance.replaceAll(',', ''));

    if (showInput === 'NaN') {
      setShowInput('');
      setinputAmount('');
    } else {
      const standardInputAmount = formatter.toStandard(String(entrance).replaceAll(',', ''));
      setinputAmount(standardInputAmount);
      setShowInput(showInput);
    }
  };

  const validateModalForm = () => {
    let isNumValid;
    if (props.editMode) {
      isNumValid = !props.isTableNumDuplicate(num, props.num);
    } else {
      isNumValid = !props.isTableNumDuplicate(num);
    }
    if (!isNumValid) {
      setNumInputInvalidMessage(
        locales('messages.fieldValueIsDuplicate', {
          fieldName: locales('fields.table.no'),
        }),
      );
      setNumInputValidateStatus('is-invalid');
    } else {
      setNumInputInvalidMessage('');
      setNumInputValidateStatus('');
    }
    let isInputAmountValid;
    if (hasInput && (inputAmount === '0' || inputAmount === '')) {
      isInputAmountValid = false;
      setInputAmountValidMessage(locales('message.input.amount.is.necessary'));
      setInputAmountValidStatus('is-invalid');
    } else {
      isInputAmountValid = true;
      setInputAmountValidMessage('');
      setInputAmountValidStatus('');
    }

    const isFormValid = isNumValid &&
      isInputAmountValid;

    return isFormValid;
  };

  const saveFormData = event => {
    const isFormValid = validateModalForm(props.editMode);
    if (!isFormValid) {
      return isFormValid;
    }

    if (props.editMode === true) {
      const foundTableItem = props.tables.find(
        x => x.itemKey === props.itemKey,
      );
      if (foundTableItem.isDeleted) {
        props.handlePlusTotalRseeTables();
      }
      props.editTableItem({
        itemKey: props.itemKey,
        num,
        totalChairs,
        allowSmoking,
        haveHeatSystem,
        floor,
        location,
        isDeleted: false,
        tableTitle,
        hasCoolingSystem,
        hasFogSpray,
        hasInput,
        inputAmount,
      });
    } else {
      props.handlePlusTotalRseeTables();
      props.addTableItem({
        itemKey: dataGenerator.generateKey('table'),
        num,
        totalChairs,
        allowSmoking,
        haveHeatSystem,
        floor,
        location,
        tableTitle,
        hasCoolingSystem,
        hasFogSpray,
        hasInput,
        inputAmount,
      });
    }
    props.closeModal();
  };

  return (
    <Modal isOpen={props.isOpen} size='lg' onOpened={handelOpenModal}>
      <ModalHeader>
        {props.editMode
          ? locales('titles.edit.table')
          : locales('titles.add.new.table')}
      </ModalHeader>
      <ModalBody>
        <form className='form-horizontal'>
          <div className='form-row'>
            <div className='form-group col d-flex required'>
              <label htmlFor='num' className='rsee-form-label'>
                {locales('fields.table.no')}
              </label>
              <div className='full-width'>
                <input
                  id='num'
                  name='num'
                  type='number'
                  className={`form-control ${numInputValidateStatus}`}
                  placeholder={locales('fields.table.no')}
                  value={num}
                  onChange={onChangeNum}
                />
                <div className='invalid-feedback'>{numInputInvalidMessage}</div>
              </div>
            </div>
            <div className='form-group col d-flex'>
              <label className='rsee-form-label'>
                {locales('table.title')}
              </label>
              <div>
                <input
                  name='tableTitle'
                  type='text'
                  className='form-control'
                  value={tableTitle}
                  onChange={onChangeTableTitle}
                />
              </div>
            </div>
            <div className='form-group col d-flex required'>
              <label htmlFor='totalChairs' className='rsee-form-label'>
                {locales('fields.table.numberOfChairs')}
              </label>
              <div className='full-width'>
                <input
                  id='totalChairs'
                  name='totalChairs'
                  type='number'
                  className='form-control'
                  placeholder={locales('fields.table.numberOfChairs')}
                  value={totalChairs}
                  onChange={onChangeTotalChairs}
                />
              </div>
            </div>
          </div>

          <div className='form-row'>
            <div className='form-group col d-flex'>
              <label className='rsee-form-label'>
                {locales('fields.floor')}
              </label>
              <div className='full-width'>
                {ENUMS.TABLE_FLOORS.list.map(x => (
                  <div className='form-check' key={x.value}>
                    <label
                      className='form-check-label'
                      htmlFor={'tableFloorRadios_' + x.value}
                    >
                      {x.title}
                    </label>
                    {'  '}
                    <input
                      className='form-check-input'
                      type='radio'
                      name='tableFloorRadios'
                      id={'tableFloorRadios_' + x.value}
                      value={x.value}
                      checked={floor === x.value}
                      onChange={onChangeTableFloor}
                    />
                  </div>
                ))}
              </div>
            </div>
            <div className='form-group col d-flex'>
              <label className='rsee-form-label'>
                {locales('fields.area')}
              </label>
              <div className='full-width'>
                {ENUMS.TABLE_LOCATIONS.list.map(x => (
                  <div className='form-check' key={x.value}>
                    <label
                      className='form-check-label'
                      htmlFor={'tableLocationRadios_' + x.value}
                    >
                      {x.title}
                    </label>
                    {'  '}
                    <input
                      className='form-check-input'
                      type='radio'
                      name='tableLocationRadios'
                      id={'tableLocationRadios_' + x.value}
                      value={x.value}
                      checked={location === x.value}
                      onChange={onChangeLocation}
                    />
                  </div>
                ))}
              </div>
            </div>
          </div>

          <div className='form-row'>
            <div className='form-group form-check '>
              <label className='form-check-label rsee-form-check-label-in-modal-lg'>
                {locales('messages.isSmokingAllowed')}
              </label>
              {'  '}
              <input
                className='form-check-input'
                type='checkbox'
                value={allowSmoking}
                checked={allowSmoking}
                onChange={onChangeAllowSmoking}
              />
            </div>
            <div className='form-group form-check '>
              <label className='form-check-label rsee-form-check-label-in-modal-lg'>
                {locales('messages.haveHeatSystem')}
              </label>
              {'  '}
              <input
                className='form-check-input'
                type='checkbox'
                value={haveHeatSystem}
                checked={haveHeatSystem}
                onChange={onChangeHaveHeatSystem}
              />
            </div>
            <div className='form-group form-check '>
              <label className='form-check-label rsee-form-check-label-in-modal-lg'>
                {locales('messages.has.cooling.system')}
              </label>
              {'  '}
              <input
                className='form-check-input'
                type='checkbox'
                value={hasCoolingSystem}
                checked={hasCoolingSystem}
                onChange={onChangehasCoolingSystem}
              />
            </div>
            <div className='form-group form-check '>
              <label className='form-check-label rsee-form-check-label-in-modal-lg'>
                {locales('messages.has.fog.spray')}
              </label>
              {'  '}
              <input
                className='form-check-input'
                type='checkbox'
                value={hasFogSpray}
                checked={hasFogSpray}
                onChange={onChangehasFogSpray}
              />
            </div>
          </div>

          <div className='form-row'>
            <div className='form-group form-check d-flex'>
              <div>
                <label className='form-check-label rsee-form-check-label-in-modal-lg'>
                  {locales('entrance')}
                </label>
                {'  '}
                <input
                  className='form-check-input'
                  type='checkbox'
                  value={hasInput}
                  checked={hasInput}
                  onChange={onChangehasInput}
                />
              </div>
              <div
                id='entrance'
                style={{ display: 'none' }}
                className='required'
              >
                <div className='form-group d-flex required'>
                  <label className='rsee-form-label'>
                    {locales('inputAmount')}
                  </label>
                  <input
                    id='inputValue'
                    className={`form-control ${inputAmountValidStatus} mr-4`}
                    placeholder={locales('tables.toman')}
                    type='text'
                    value={showInput}
                    onChange={onChangeinputAmount}
                  />
                  <div className='invalid-feedback'>
                    {inputAmountValidMessage}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </form>
      </ModalBody>
      <ModalFooter>
        <button
          onClick={saveFormData}
          type='button'
          className='btn btn-success'
        >
          {props.editMode
            ? locales('labels.do.edit')
            : locales('labels.do.add')}
        </button>
        <button type='button' className='btn' onClick={cancel}>
          {locales('labels.cancel')}
        </button>
      </ModalFooter>
    </Modal>
  );
};

export default AddOrEditTableModal;
